import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';
import {push} from 'react-router-redux';

/* import {clearLabelSheet, createCalibrationLink, getCustomDefinitions, getDefinitions, savePageSetup, selectLabelSize, togglePLU} from '../actions';
import {getActivePageSize, getCalibrationLink, areDefinitionsValid, getLabelDefinitions, getLabels, getPdfId, isPLUActive} from '../selectors'; */

import {clearLabelSheet, getCustomDefinitions, getDefinitions, savePageSetup, selectLabelSize, togglePLU} from '../actions';
import {getActivePageSize, areDefinitionsValid, getLabelDefinitions, getLabels, getPdfId} from '../selectors';

import customer from '../../customer';
const {getActivePageOffset, getActivePermissions} = customer.selectors;

import LabelPageButtons from './LabelPageButtons';
import LabelSheet from './LabelSheet';
import LabelSizeList from './LabelSizeList';
//import PLUChangeModal from './PLUChangeModal';
//import PLUSelector from './PLUSelector';
import PageSetupModal from './PageSetupModal';

import * as permissions from '../../common/userPermissions';

class LabelsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pluModalOpen: false,
      setupModalOpen: false
    };
  }

  componentWillMount() {
    const labelAccess = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_LABELS;
    });
    if(!labelAccess)
    {
      this.props.actions.push('/no_access');
    }

    if(!this.props.definitionsValid) {
      this.props.actions.getDefinitions();
    }

  /*   this.props.actions.createCalibrationLink(); */
  }
  
/*   handleTogglePLU = () => {
    this.setState({pluModalOpen: true});
  }

  handleHidePluModal = () => {
    this.setState({pluModalOpen: false});
  }

  handlePLUChange = () => {
    this.props.actions.togglePLU();
    this.handleHidePluModal();
  } */

  handleLabelSize = (labelSize) => {
    this.props.actions.selectLabelSize(labelSize);
    this.props.actions.getCustomDefinitions(labelSize);
  }

  handleShowSetupModal = () => {
    this.setState({setupModalOpen: true});
  }

  handleHideSetupModal = () => {
    this.setState({setupModalOpen: false});
  }

  handleSetupChange = (verticalOffset, horizontalOffset) => {
    this.props.actions.savePageSetup(this.props.activePageSize, verticalOffset, horizontalOffset);
  }

  render() {
    /* const {actions, activePageSize, activePLU, calibrationLink, definitions, definitionsValid, labelList, pageOffset, pdfId} = this.props; */
    const {actions, activePageSize, definitions, definitionsValid, labelList, pageOffset, pdfId} = this.props;

    return (
      <div className="container-fluid main labels" id="main">
        {!definitionsValid && <div className="loading"/>}
        {definitionsValid && <div><div className="row label-info">
          <div className="col-lg-12">
            <h1>{I18n.t('LABELS')}</h1>
            <div className="label-form">
              <div className="row no-gutters">
                <LabelSizeList activeSize={activePageSize} definitions={definitions} onSelected={this.handleLabelSize}/>
                <div className="col-xl-12 col-sm-6 p-0 mid">
                  <div className="row no-gutters p-0 m-0">
                    {/* <PLUSelector active={activePLU} onToggle={this.handleTogglePLU}/> */}
                    <div className="col-xl-1 col-sm-1">
                      
                     
                    </div>
                    <div className="col-xl-12 col-sm-4">
                      <Link to="/customize_label" className="label-link customize">{I18n.t('CUSTOMIZE_COLORS_LOGO')}</Link>   
                     
                    </div>
                    <div className="col-xl-12 col-sm-4">
                     
                      <Link to="/advanced_settings_label" className="label-link customize">{I18n.t('ADVANCED_SETTINGS_LINK')}</Link>   
                    </div>
                    <div className="col-xl-1 col-sm-1">
                      
                     
                      </div>
{/*                     <div className="col-xl-12 col-sm-4">
                      <button className="label-link btn-link" onClick={this.handleShowSetupModal}>{I18n.t('PAGE_SETUP')}</button>
                    </div> */}
                  </div>
                </div> 
                <LabelPageButtons onClear={actions.clearLabelSheet} pdfId={pdfId}/>
              </div>
            </div>  
          </div>
        </div>
        <LabelSheet labels={labelList}/></div>}
        {/* <PLUChangeModal isOpen={this.state.pluModalOpen} onClose={this.handleHidePluModal} onAccept={this.handlePLUChange}/> */}
        <PageSetupModal isOpen={this.state.setupModalOpen} 
                        onClose={this.handleHideSetupModal} 
                        onAccept={this.handleSetupChange} 
                        offsetValue={pageOffset}
                        />
                        {/* calibrationLink={calibrationLink} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activePageSize: getActivePageSize(state),
    activePermissions: getActivePermissions(state),
//    activePLU: getUsePLUCode(state),
    // calibrationLink: getCalibrationLink(state),
    definitions: getLabelDefinitions(state),
    definitionsValid: areDefinitionsValid(state),
    labelList: getLabels(state),
    pageOffset: getActivePageOffset(state),
    pdfId: getPdfId(state),

  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({clearLabelSheet, 
            //                      createCalibrationLink, 
                                  getCustomDefinitions, 
                                  getDefinitions, 
                                  savePageSetup, 
                                  selectLabelSize, 
                                  togglePLU, 
                                  push}, dispatch)
  };
}

LabelsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePageSize: PropTypes.string.isRequired,
  activePermissions: PropTypes.array.isRequired,
  //activePLU: PropTypes.bool.isRequired,
  definitions: PropTypes.array.isRequired,
  definitionsValid: PropTypes.bool.isRequired,
  labelList: PropTypes.array.isRequired,
  pageOffset: PropTypes.object.isRequired,
  pdfId: PropTypes.string.isRequired,

};

LabelsPage.defaultProps = {
  activePermissions: [],
  pageOffset: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelsPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelsPage.js
 **/